import React from 'react';
import { Typo } from 'components/Layout';
import { ProBadge } from 'components/Badge';
import Tutorial from 'components/Tutorial';
import cx from 'classnames';
import Note from 'components/Note';

import styles from './styles.css';

export type Props = {
  title?: string | any;
  description?: string;
  pro?: boolean;
  tutorial?: string;
  notes?: [React.ReactElement | string];
  [x: string]: any;
};

export const PageTitle = ({
  title,
  description,
  pro,
  tutorial,
  notes,
  tail,
  ...rest
}: Props) => (
  <div
    className={cx(styles.root, description && styles.withDescription)}
    {...rest}
  >
    <div className={styles.titleRoot}>
      <Typo.Title>
        {title}
        {tail && <i>({tail})</i>}
        {pro && ProBadge}
        {!!tutorial && <Tutorial url={tutorial} title={title} />}
      </Typo.Title>
    </div>
    {description && <Typo.Paragraph>{description}</Typo.Paragraph>}
    {notes && notes.map((note, index) => <Note key={index} children={note} />)}
  </div>
);
